export default __webpack_public_path__ + "static/media/IMG_3070_8_11zon.6e86a0cf.jpg";